module.exports = __webpack_public_path__ + "static/media/american.509c4ad2.jpg";